/**
 * Angular imports.
 */
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

/**
 * Environment imports.
 */
import { environment } from '../../../environments/environment';

/**
 * Modal imports.
 */
import { Profile, Speciality, Profession, AlPoint } from '../../interface/userprofile/userprofile';

/**
 * Service imports.
 */
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { SetprofileService } from '../../dataservices/profile/setprofile.service';
import { LocalstorageService } from '../../auth/localstorage.service';
import { AuthService } from '../../auth/auth.service';
import { EncryptionService } from '../../auth/encryption.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { EventMsgService } from '../../dataservices/master-service/event-msg.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { ImageGroupService } from '../../dataservices/master-service/image-group.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';
/**
 * Interface import.
 */
import { AnalyticsInterface } from '../../analytics-event/analytics.model';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';

/**
 * Constant import.
 */
import { EXPLORE_SECTION, SCREEN_NAME, PRODUCT_TYPE_CONSTANT, NEW_TAG, NUMBERS, BREAKPOINTS_WIDTH, ACTION_TYPE, CTA_TYPE, ACTION_ON, PRODUCT_TYPE_CONSTANT_NAME, PRODUCT_TYPE_NUMBER_MAPPING } from '../../constants/app.constants';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { EXPLORE_SECTION_HAMBURGER } from '../../constants/data-testId.constants';
import { Analytics } from 'analytics2.0';
import { CLICK } from 'analytics2.0/dist/core/constants/analytic.interface';
import { GetService } from 'src/app/dataservices/get.service';

// ************Interface*************

/**
 * Profile Left Component
 */
@Component({
  selector: 'app-profile-left',
  templateUrl: './profile-left.component.html',
  styleUrls: ['./profile-left.component.scss']
})
export class ProfileLeftComponent implements OnInit, OnDestroy {
  public profile_left_pic_image = {
    prflclass: 'box-size-50 text-center rounded-circle d-table-cell align-middle',
    prflpic: '',
    prflfname: '',
    prflmname: '',
    prfllname: '',
    prflrname: '',
    prflcid: '',
    prfltype: '',
    prflpicclass: 'rounded-circle box-size-50 post-pic',
    badge: { is_verified: 0, is_show: true },
    full_name: '',
    is_action: true,
    anonymous: '0',
    partial_permission_state: ''
  };
  public veiew_detail = 'veiew detail';
  public webSiteUrl = environment.baseUrls.webSiteUrl;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userProfileData: any;
  public screenHeight = 0;
  public profileInfo: Profile;
  public userSpeciality: Speciality[];
  public userProfession: Profession[];
  public userReferalPoint: AlPoint;
  public userCmePoint: AlPoint;
  public uploadProfile = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public activeModule: any;
  public edit_profile_pic_path = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public responce_upload_file: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userData: any;
  public loginUserCustomeId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public custom_id: any;
  public userProfile: Profile;
  public finished = false;
  public primary_speciality = '';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public config: any;
  public screen_name = '';
  public activate_media = false;

  /**
   * used for holding string
   */
  public tag_string = NEW_TAG.NEW;

  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * used to hold explore section data.
   */
  public exploreSection = EXPLORE_SECTION;

  /**
   * Analyticsdata object.
   */
  public analyticsData: AnalyticsInterface;
  /**
   * Session time object.
   */
  public sessiontime = { 'start_time': '', 'end_time': '' };

  /**
   * Constant for data test id.
   */
  public dataTestId = EXPLORE_SECTION_HAMBURGER;

  /**
   * selected menu item in left navigation
   */
  public selectedMenuItem = '';

  /**
   * tracks screen scroll up or down
   */
  isScreenScrolledUp = false;


  /**
  * Necessary instances.
  */
  constructor(
    public dss: DataStorageService,
    public igs: ImageGroupService,
    public ems: EventMsgService,
    private authService: AuthService,
    private localStorage: LocalstorageService,
    private setprofileService: SetprofileService,
    public multiLangService: MultiLangService,
    private router: Router,
    public masterService: MasterserviceService,
    public funCollectionService: FunCollectionService,
    public mls: NewLanguageService,
    private encrypt: EncryptionService,
    private analyticsEventService: AnalyticsEventService,
    private analyticSdk: Analytics,
    private GetSer: GetService,) {
    this.subscriptions.add(this.masterService.profile_api_data.subscribe(data => {
      this.userProfileData = data;
      this.profileInfo = this.userProfileData.data['profile'];
      this.userSpeciality = this.userProfileData.data['speciality'];
      this.userProfession = this.userProfileData.data['profession'];
      this.userReferalPoint = this.userProfileData.data['referal_point'];

      this.userCmePoint = this.userProfileData.data['total_point'];
      for (let i = 0; i < this.userSpeciality.length; i++) {
        if (this.userSpeciality[i].is_primary == 1) {
          this.primary_speciality = this.userSpeciality[i].speciality_name;
          break;
        }
      }
    }));

    const temp = this.router.url.split('/profile/');
    if (temp.length >= 2) {
      this.activate_media = true;
      this.custom_id = temp[1];
      this.custom_id = this.custom_id.split('/');
      this.custom_id = this.custom_id[0];
    } else {
      this.activate_media = false;
    }

    this.subscriptions.add(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeModule = event.urlAfterRedirects;
        const temp = this.activeModule = this.activeModule.split('/');
        this.activeModule = this.activeModule[2];

        if (temp.length > 3 && this.activeModule == 'profile') {
          this.activate_media = true;
          this.custom_id = temp[3];
        } else {
          this.activate_media = false;
        }
      }
    }));
    this.screen_name = 'Profile';
    if (this.dss.user_profile_data) {
      this.profile_left_pic_image.prflpic = this.dss.user_profile_data.profile.profile_pic_path;
      this.profile_left_pic_image.prflcid = this.dss.user_profile_data.profile.custom_id;
      this.profile_left_pic_image.prflrname = this.dss.user_profile_data.profile.registered_name;
      this.profile_left_pic_image.prflfname = this.dss.user_profile_data.profile.first_name;
      this.profile_left_pic_image.prfllname = this.dss.user_profile_data.profile.last_name;

      this.profile_left_pic_image.full_name = this.dss.user_profile_data.full_name;
      this.profile_left_pic_image.badge.is_verified = (this.dss.user_profile_data.profile.permission == 'all') ? 1 : 0;
      this.profile_left_pic_image.partial_permission_state = this.dss.user_profile_data.profile.partial_permission_state;
    }

  }

  /**
   * window:scroll event binding.
   */
  @HostListener('window:scroll.out-zone', ['$event'])
  onScroll(): void {
    this.screenHeight = window.scrollY;
  }

  /**
   * edit Profile Pic
   */
  editProfilePic(): void {
    this.uploadProfile = true;
    this.edit_profile_pic_path = this.profileInfo.profile_pic_path;
  }

  /**
   * file Change Event
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fileChangeEvent(fileInput: any): boolean {
    let file_type = '';
    let file_size = '';
    file_type = fileInput.target.files[0].type;
    file_size = fileInput.target.files[0].size;
    if (file_type == 'image/jpeg' || file_type == 'image/png' || file_type == 'image/jpg') {
      // tslint:disable-next-line: radix
      const bytes = (parseInt(file_size) / (1024 * 1024)).toFixed(0);

      // tslint:disable-next-line: radix
      if (parseInt(bytes) > 14) {
        return false;
      } else {
        this.finished = true;
      }
    }
  }

  /**
   * update Profile Pic
   */
  updateProfilePic(): void {
    this.userData = { 'identifier': 'profile', 'id': 0, 'key': 'profile_pic_path', 'action': 'update', 'value': this.responce_upload_file.fileurl, 'second_value': '' };
    this.userData = JSON.stringify(this.userData);
    this.subscriptions.add(this.setprofileService.setProfileSingleValue(this.userData).subscribe(data => {
      if (data.status == 1) {
        this.uploadProfile = false;
        this.userProfileData.data['profile'].profile_pic_path = this.responce_upload_file.absolute_path;
        this.masterService.login_user_profile_pic = this.responce_upload_file.absolute_path;
        const xprofiledata = (JSON.parse(this.encrypt.decryptAes(this.localStorage.getInSessionStorage('loginuserProfileData'))));
        xprofiledata.profile_pic_path = this.masterService.login_user_profile_pic;
        this.localStorage.setInSessionstorage('loginuserProfileData', this.encrypt.encryptAes(JSON.stringify(xprofiledata)));

        this.profileInfo = this.userProfileData['profile'];
        this.masterService.profile_api_data.next(this.userProfileData);
        this.localStorage.setInSessionstorage('userProfileData', this.encrypt.encryptAes(JSON.stringify(this.userProfileData)));
      }
    }));
  }

  /**
   * cancel File Change Event
   */
  cancelFileChangeEvent(): void {
    this.uploadProfile = false;
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    document.querySelector<HTMLElement>('#profile_show_hide').style.display = 'block';
    this.loginUserCustomeId = this.authService.getbyName('profile_obj');
    this.dss.feed_filter.subscribe(data => {
      if (data && data[0] && data[0].key === 'speciality') {
        this.selectedMenuItem = '';
      }
    });
  }
  /**
   * navigate To Referal
   */
  navigateToReferal(): void {
    if (this.loginUserCustomeId === this.profileInfo.custom_id) {
      this.funCollectionService.navigateToReferal();
    }
  }

  /**
   * navigate To Reward
   */
  navigateToReward(): void {
    if (this.loginUserCustomeId === this.profileInfo.custom_id) {
      this.router.navigateByUrl('refer-and-earn/reward');
    }
  }
  /**
    * Get the current time in string.
    */
  getTimeString(): string {
    return new Date().getTime().toString();
  }
  /**
   * navigate To Profile
   */
  navifateToProfile(): void {
    const analyticsData = {
      event_name: EVENT_NAME.PROFILE_ENTRY,
      product_type: 0,
      product_type_id: 0,
      screen_name: SCREEN_NAME.GRAND_ROUND,
      start_time: this.getTimeString(),
      end_time: this.getTimeString()
    };
    this.analyticsEventService.logAnalyticsEvent(analyticsData, false, false);
    if (this.activeModule != 'profile') {
      if (localStorage.getItem("fromOpenAccess") == '1') {
        this.loginUserCustomeId = localStorage.getItem("userCUstomId")
      }
      this.funCollectionService.navigateToUserProfie(this.loginUserCustomeId);
    }
  }

  /**
   * navigate To CME
   */
  navigateToCme(): void {
    if (this.loginUserCustomeId === this.profileInfo.custom_id) {
      this.router.navigateByUrl('cme');
    }
  }

  /**
   * hide Modal
   */
  hideModal(): void {
    this.uploadProfile = false;
  }

  /**
   * navigate To User Post
   */
  navigateToUserPost(): void {
    this.funCollectionService.navigateToUserPosts(this.dss.user_profile_data.profile.custom_id);
  }

  /**
   * navigate From Explore
   */
  navigateFromExplore(exp): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }
    this.dss.setCalDayMonthYr();

    const date = new Date();
    this.sessiontime.start_time = date.getTime().toString();
    if (exp.value) {
      this.logClickEvent(exp.value, CTA_TYPE.OPTION );
    }
    this.funCollectionService.currentScreename = SCREEN_NAME.EXPLORE_LIST;
    switch (exp.value) {

      /**********************group sort order 1*****************/
      case 'pharma': {
        this.masterService.url_after_leave_cme = '/channel/list';
        this.router.navigateByUrl('/pharma/list');
        break;
      }
      case 'news': {
        this.masterService.url_after_leave_cme = '/news/list';
        this.router.navigateByUrl('/news/list');
        break;
      }
      case 'drugsample': {
        this.masterService.url_after_leave_cme = '/drugsample/list/drugs';
        this.router.navigateByUrl('/drugsample/list/drugs');
        break;
      }
      case 'cme': {
        /**
         * Set analyics data on click.
         */
        this.analyticsData = {
          'event_name': EVENT_NAME.EXPLORE_CME_CLICK,
          'product_type': PRODUCT_TYPE_CONSTANT.CME,
          'product_type_id': 0,
          'screen_name': SCREEN_NAME.GRAND_ROUND,
          'start_time': this.sessiontime.start_time,
          'end_time': this.sessiontime.start_time
        };
        this.analyticsEventService.logAnalyticsEvent(this.analyticsData);

        this.masterService.url_after_leave_cme = '/cme';
        this.router.navigateByUrl('/cme');
        break;
      }
      case 'channel': {
        this.masterService.url_after_leave_cme = '/channel/list';
        this.router.navigateByUrl('/pharma/list');
        break;
      }
      case 'productchannel': {
        this.funCollectionService.navigateToChannelDetail(exp.product_id);
        break;
      }
      case 'event': {
        this.masterService.url_after_leave_cme = '/event/list/upcoming';
        this.funCollectionService.navigateToEventDetail(0);
        break;
      }
      case 'online_event': {
        this.masterService.url_after_leave_cme = '/event/list/upcoming';
        this.funCollectionService.navigateToNewEventDetail(0);
        break;
      }
      case 'journal': {
        this.masterService.url_after_leave_cme = '/clinical';
        this.router.navigateByUrl('/clinical/list');
        break;
      }
      /**********************group sort order 2*****************/
      case 'clinicalcases': {
        this.dss.feed_filter.next([{ 'key': 'properties', 'value': ['cases'] }]);
        this.selectedMenuItem = exp.value;
        break;
      }
      case 'insights': {
        sessionStorage.removeItem('feed_kind_filter');
        sessionStorage.removeItem('speciality_filter');
        const feed_kind_filter = { filter_type: 'kind', filter_id: ['post'] };
        this.localStorage.setInSessionstorage('feed_kind_filter', this.encrypt.encryptAes(JSON.stringify(feed_kind_filter)));
        this.masterService.url_after_leave_cme = 'web/filter/' + this.funCollectionService.makeid();
        this.router.navigateByUrl('web/filter/' + this.funCollectionService.makeid());
        break;
      }
      case 'poll': {
        this.dss.feed_filter.next([{ 'key': 'properties', 'value': ['poll'] }]);
        this.selectedMenuItem = exp.value;
        break;
      }
      case 'chats': {
        if (this.dss.user_profile_data.profile.permission != 'all') {
          this.funCollectionService.assignAssociation('open_chat');
        } else {
          this.funCollectionService.navigateToChat();
        }
        break;
      }
      /**********************group sort order 3*****************/
      case 'mydownload': {
        break;
      }
      case 'mybookmarks': {
        this.masterService.url_after_leave_cme = '/webprofile/bookmark/case';
        this.router.navigateByUrl('/webprofile/bookmark/case');
        break;
      }
      case 'qna': {
        this.masterService.url_after_leave_cme = '/web/profile/' + this.loginUserCustomeId + '/qa';

        this.funCollectionService.navigateToUserProfie_spe_sec(this.loginUserCustomeId, 'qa');
        break;
      }
      case 'settings': {
        break;
      }
      case 'rewards': {
        this.masterService.url_after_leave_cme = 'refer-and-earn/referral';
        this.funCollectionService.navigateToReferal();
        break;
      }

      case 'doctalk': {
        this.masterService.url_after_leave_cme = 'doctalk/list';
        this.funCollectionService.navigateToDoctalk();
        break;
      }
      case 'connection': {
        this.masterService.url_after_leave_cme = 'connection/suggestion';
        const analyticsData = {
          event_name: EVENT_NAME.CONNECTION_DASHBOARD_ENTRY,
          product_type: 0,
          product_type_id: 0,
          screen_name: null,
          start_time: this.getTimeString(),
          end_time: this.getTimeString()
        };
        this.analyticsEventService.logAnalyticsEvent(analyticsData, false, true);
        this.funCollectionService.navigateToConnection();
        break;
      }

      case 'survey': {
        /**
         * Set analyics data on click.
         */
        this.analyticsData = {
          'event_name': EVENT_NAME.EXPLORE_SURVEY_CLICK,
          'product_type': PRODUCT_TYPE_CONSTANT.SURVEY,
          'product_type_id': 0,
          'screen_name': SCREEN_NAME.GRAND_ROUND,
          'start_time': this.sessiontime.start_time,
          'end_time': this.sessiontime.start_time
        };
        this.analyticsEventService.logAnalyticsEvent(this.analyticsData);
        this.masterService.url_after_leave_cme = 'survey/list/all';
        this.funCollectionService.navigateToSurvey();
        break;
      }
      case 'clinical': {
        this.masterService.url_after_leave_cme = '/clinical';
        this.router.navigateByUrl('/clinical/list');
        break;
      }

      case 'webinar': {
        this.masterService.url_after_leave_cme = '/webinar';
        this.router.navigateByUrl('/webinar/list/all');
        break;
      }

      case 'posting': {
        if (this.mls.featureOnOffList.featureList.poll.value || !this.mls.userLoginFlow) {
          this.dss.show_feed_post_modal.next(1);
        }
        else {
          this.mls.toShowNologinRestrictionPopUp = true;
        }
        break;
      }
      case 'gr': {
        this.funCollectionService.navigateToFeedDetail(exp.product_id);
        break;
      }

      case 'tnc': {
        if (exp.target_url != '') {
          window.open(exp.target_url, '_blank');
          break;
        }
        break;
      }

      case 'dx': {
        this.funCollectionService.getDXToken();
        break;
      }

      case 'otsuka_form': {

        this.analyticsData = {
          'event_name': EVENT_NAME.EXPLORE_OTSUKA_CLICK,
          'product_type': 0,
          'product_type_id': 0,
          'screen_name': SCREEN_NAME.GRAND_ROUND,
          'start_time': this.sessiontime.start_time,
          'end_time': this.sessiontime.start_time
        };
        this.analyticsEventService.logAnalyticsEvent(this.analyticsData);

        this.funCollectionService.navigateToPatientList();
        break;
      }

      case 'vault': {
        this.funCollectionService.navigateToVault();
        break;
      }

      case 'gr_filter': {
        const filter = JSON.parse(exp.target_url);
        this.dss.feed_filter.next(filter);
        break;
      }

      case 'calender': {
        this.funCollectionService.navigateToCalenderModule();
        break;
      }

      case 'community': {
        /**
         * Set analyics data on click.
         */
        this.funCollectionService.navigateToCommunityModule();
        break;
      }

      case 'editors_choice': {
        /**
         * Set analyics data on click.
         */
        this.dss.feed_filter.next([{ key: 'properties', value: ['editors_choice'] }]);
        this.selectedMenuItem = exp.value;
        break;
      }

      case 'link': {
        /**
         * Set analyics data on click.
         */
        this.analyticsData = {
          'event_name': EVENT_NAME.EXPLORE_INSIGHT_COLLECTOR_CLICK,
          'product_type': 0,
          'product_type_id': 0,
          'screen_name': SCREEN_NAME.GRAND_ROUND,
          'start_time': this.sessiontime.start_time,
          'end_time': this.sessiontime.start_time
        };
        this.analyticsEventService.logAnalyticsEvent(this.analyticsData);
        window.open(exp?.target_url, "_self");
        break;
      }
    }
  }

  logClickEvent(actionOn: string, ctaType: string): void {
    this.analyticSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.OTHER, 0, SCREEN_NAME.EXPLORE_LIST, ctaType, ACTION_TYPE.CLICK, actionOn, null);
  }
  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  /**
   * Naviagte to DX
   */
  navigateToDX():void{
    this.funCollectionService.getDXToken();
  }

}
